import React from 'react';

import { VerifiedIcon } from '@ocx/ui-icons';

import { IconButton } from '../icon-button';

export type VerifiedButtonProps = {
  isVerified: boolean;
  onClick?(): void;
};

export const VerifiedButton = (props: VerifiedButtonProps) => {
  const { onClick, isVerified = true } = props;
  return (
    <IconButton
      sx={(theme) => ({
        backgroundColor: isVerified ? theme.palette.success.light : theme.palette.error.light,
        '&:hover': {
          background: isVerified ? theme.palette.success.light : theme.palette.error.light,
        },
      })}
      onClick={onClick}>
      <VerifiedIcon color={`${isVerified ? 'success' : 'error'}`} />
    </IconButton>
  );
};
